import { render, staticRenderFns } from "./PopupCopyResult.vue?vue&type=template&id=8978f9dc&"
import script from "./PopupCopyResult.vue?vue&type=script&lang=ts&"
export * from "./PopupCopyResult.vue?vue&type=script&lang=ts&"
import style0 from "./PopupCopyResult.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports